module.exports = __webpack_public_path__ + "static/media/not-feeling-good-enough@2x.653e2370.png";